/**
 * Códigos das funcionalidades que o front consulta pelo nome: `data.featureCode` de rota e
 * `PermissaoService.checkAcessoFeature`. Quase todas são internas, sem módulo comercial, concedidas
 * por papel em `apl_papel_acesso_funcionalidade` (o Super Administrador as recebe pelo nível 0);
 * `DADOS_RPS` também chega pelos módulos da operadora.
 *
 * Cada valor espelha um `apl_funcionalidade.cd_funcionalidade` cadastrado no banco. Renomear ou
 * remover um código aqui exige o mesmo ajuste no cadastro (e nas concessões), e vice-versa: código
 * que não existe no banco nunca chega na lista, e o que ele protege some para todos.
 */
export const FUNCIONALIDADE = {
  GERENCIAR_VISOES: 'GRID.GERENCIAR_VISOES',
  DESLIGAR_PSEUDONIMIZACAO: 'DADOS.DESLIGAR_PSEUDONIMIZACAO',
  VISUALIZAR_ORIGEM_CONSULTA: 'SUPORTE.VISUALIZAR_ORIGEM_CONSULTA',
  EDITAR_ORIENTACOES: 'SUPORTE.EDITAR_ORIENTACOES',
  EDITAR_SIMULADO_OFICIAL: 'SIMULADOR.EDITAR_SIMULADO_OFICIAL',
  USUARIOS: 'ADMIN.USUARIOS',
  OPERADORAS: 'ADMIN.OPERADORAS',
  GERENCIAR_USUARIOS: 'ADMIN.USUARIOS.GERENCIAR',
  REDEFINIR_SENHA: 'ADMIN.USUARIOS.REDEFINIR_SENHA',
  DADOS_RPS: 'DADOS_PRESTADOR.DADOS_RPS',
} as const;
